import PromptModal from "@/components/common/PromptModal";
import { asyncModal } from "@/components/ui/modal/utils";

export default function showPrompt(
  message,
  inputType = "text",
  validateFunc = () => false
) {
  return asyncModal({
    name: "app-prompt-modal",
    component: PromptModal,

    escapable: false,
    closeOnBackdrop: false,
    closable: false,

    props: {
      message,
      inputType,
      validateFunc
    }
  });
}
